import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFireFlameCurved } from "@fortawesome/free-solid-svg-icons";

const saudacaoPorHora = (hora) => {
  if (hora < 12) return "Bom dia!";
  if (hora < 18) return "Boa tarde!";
  return "Boa noite!";
};

const DailyHeader = ({ streak = 0 }) => {
  const hoje = new Date();

  const dataFormatada = hoje.toLocaleDateString('pt-BR', {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
  });

  return (
    <div className="mb-4">
      <h4 className="mb-1">{saudacaoPorHora(hoje.getHours())}</h4>
      <div className="text-muted text-capitalize">
        {dataFormatada}
        {streak > 0 && (
          <span className="ms-2">
            <FontAwesomeIcon icon={faFireFlameCurved} className="me-1 text-warning" />
            Dia {streak} de sequência
          </span>
        )}
      </div>
    </div>
  );
};

export default DailyHeader;
